import ApiService from './services/ApiService'
import { setupApp } from './setup'

setupApp().then((app) => {
  app.mount('#app')

  app.config.errorHandler = (err: any, instance, info) => {
    console.error('Global Vue error:', err)

    // if (process.env.NODE_ENV === 'production') {
    if (import.meta.env.MODE) {
      ApiService.reportError(err)
    }
  }
})
